<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17FCz5M/media/FC-9781398495098.jpg?1692049837678" alt="This image is the cover for the book The Test"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Test
      </h1>
      <p class="bookDescription body article font2">
        <p>Power from the gods. Myths, legends, and a forgotten world. Bek is sixteen and life is hard... in an ordinary kind of way. School is tough; home is worse, and she wishes things would change. And for once, change comes. Bek unwittingly sets an ancient test in motion, imbuing her with godlike powers and opening her eyes to an unseen world. Finally liberated from her dismal reality, this exciting discovery takes a darker turn as Bek is thrust into the middle of a primordial war between the natural and the supernatural. She may have the power, but for how long? Forced into a quest for survival, being hunted by creatures she cannot comprehend, Bek must learn to trust others with her life. She must choose whether to run and hide, or stand and fight.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Miriam Sarin
      </h2>
      
      <p class="authorDescription body article">Miriam grew up in the bracing seaside town of Skegness. She inherited her love of story from her grandad, whose Christmas tradition was a glorious and giant sack full of books to dive into. Storytime evolved into a career as an actor; touring theatre, a tight-knit, fast-paced industry in which she was given the opportunity to write, direct and examine story from every angle. After an exhilarating decade, she left performance work to pursue her growing passion for creative writing, driving her adventure onwards to a Masters in Writing at Birmingham City University. And there, the idea for The Test sparked and a new chapter opened…</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4285b05f